var map = {
	"./HelloReact": 3215,
	"./HelloReact.jsx": 3215,
	"./follower/account_margin_status": 3979,
	"./follower/account_margin_status.tsx": 3979,
	"./follower/advanced_settings_form": 5626,
	"./follower/advanced_settings_form.tsx": 5626,
	"./follower/currency_icon": 4039,
	"./follower/currency_icon.tsx": 4039,
	"./follower/home_account_status": 8278,
	"./follower/home_account_status.tsx": 8278,
	"./follower/home_subscription_status": 2403,
	"./follower/home_subscription_status.tsx": 2403,
	"./follower/onboarding_contents": 4549,
	"./follower/onboarding_contents.tsx": 4549,
	"./follower/open_trade_modal/actions_button": 5292,
	"./follower/open_trade_modal/actions_button.tsx": 5292,
	"./follower/open_trade_modal/open_trade_modal": 9453,
	"./follower/open_trade_modal/open_trade_modal.tsx": 9453,
	"./follower/open_trade_modal/profit_loss_section": 2068,
	"./follower/open_trade_modal/profit_loss_section.tsx": 2068,
	"./follower/open_trade_modal/tp_sl_field": 5638,
	"./follower/open_trade_modal/tp_sl_field.tsx": 5638,
	"./follower/open_trade_modal/trade_card": 7093,
	"./follower/open_trade_modal/trade_card.tsx": 7093,
	"./follower/subscription_modal": 5688,
	"./follower/subscription_modal.tsx": 5688,
	"./follower/toggle_switch": 5899,
	"./follower/toggle_switch.tsx": 5899,
	"./footer_news_navbar_text": 8943,
	"./footer_news_navbar_text.tsx": 8943,
	"./provider/follower_balance_column_content": 6218,
	"./provider/follower_balance_column_content.tsx": 6218,
	"./provider/follower_subscription_column_content": 4818,
	"./provider/follower_subscription_column_content.tsx": 4818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 982;